var angularModule = angular.module('t2g.common.filter.orFilter', []);

module.exports = angularModule;

angularModule.filter('orFilter', function() {
  return function(items, attributes, filterString) {
    var matchedItems = [];
    filterString = filterString.toLowerCase();

    if (items) {
      for (var i = 0, itemLen = items.length; i < itemLen; i++) {
        for (var j = 0; j < attLen; j++) {
          if (items[i][attributes[j]]) {
            if (items[i][attributes[j]].toLowerCase().indexOf(filterString) != -1) {
              matchedItems.push(items[i]);
              break;
            }
          }
        }
      }
    }

    return matchedItems;
  };
});



// WEBPACK FOOTER //
// ./src/app/common/filter/orFilter.js